<div
	#editorHost
	class="contract-code-editor"
	[class.contract-code-editor--editable]="editable"
	[attr.aria-label]="editable ? 'Editor do contrato' : 'Conteúdo do contrato'"
></div>
